import FileExcel from '@/Theme/icons/fileIcons/fileexcel';
import FilePDF from '@/Theme/icons/fileIcons/filepdf';
import FilePowerPoint from '@/Theme/icons/fileIcons/filepowerpoint';
import FileVideo from '@/Theme/icons/fileIcons/filevideo';
import FileWord from '@/Theme/icons/fileIcons/fileword';
import FileMusic from '@/Theme/icons/fileIcons/musicfile';
import FileText from '@/Theme/icons/fileIcons/textfile';
import WebFile from '@/Theme/icons/fileIcons/webfile';

export const getLabelMinutes = (seconds) => {
    let minutes = Math.floor(seconds / 60);
    let remainingSeconds = seconds % 60;
    let minutesStr = minutes < 10 ? '0' + minutes : minutes.toString();
    let secondsStr =
        remainingSeconds < 10
            ? '0' + remainingSeconds
            : remainingSeconds.toString();
    return minutesStr + ':' + secondsStr;
};

export const getIconFile = (type, file) => {
    let iconComponent;

    switch (type) {
        case 'pdf':
            iconComponent = (
                <div className="mx-2 mt-1  h-7 w-7">
                    <FilePDF color={themeValue === 'dark' ? '#7379FF' : '#5256A6'} />
                </div>
            );
            break;
        case 'youtube':
            iconComponent = (
                <img src={file.metadata.thumbnail} className="w-16 h-10 mt-1"></img>
            );
            break;
        case 'webpage':
            iconComponent = (
                <div className="mx-2 mt-1  h-7 w-7">
                    <WebFile color={themeValue === 'dark' ? '#7379FF' : '#5256A6'} />
                </div>
            );
            break;
        case 'docx':
            iconComponent = (
                <div className="mx-2 mt-1 h-7 w-7">
                    <FileWord color={themeValue === 'dark' ? '#7379FF' : '#5256A6'} />
                </div>
            );
            break;
        case 'pptx':
            iconComponent = (
                <div className="mx-2 mt-1  h-7 w-7">
                    <FilePowerPoint
                        color={themeValue === 'dark' ? '#7379FF' : '#5256A6'}
                    />
                </div>
            );
            break;
        case 'xlsx':
            iconComponent = (
                <div className="mx-2 mt-1 h-7 w-7">
                    <FileExcel color={themeValue === 'dark' ? '#7379FF' : '#5256A6'} />
                </div>
            );
            break;
        case 'txt':
            iconComponent = (
                <div className="mx-2 mt-1 h-7 w-7">
                    <FileText color={themeValue === 'dark' ? '#7379FF' : '#5256A6'} />
                </div>
            );
            break;
        case 'mp3':
            iconComponent = (
                <div className="mx-2 mt-1 h-7 w-7">
                    <FileMusic color={themeValue === 'dark' ? '#7379FF' : '#5256A6'} />
                </div>
            );
            break;
        case 'mp4':
            iconComponent = (
                <div className="mx-2 mt-1  h-7 w-7">
                    <FileVideo color={themeValue === 'dark' ? '#7379FF' : '#5256A6'} />
                </div>
            );
            break;
        case 'json':
            iconComponent = (
                <div className="mx-2 mt-1 h-7 w-7">
                    <FileText color={themeValue === 'dark' ? '#7379FF' : '#5256A6'} />
                </div>
            );
            break;
        case 'html':
            iconComponent = (
                <div className="mx-2 mt-1 h-7 w-7">
                    <FileText color={themeValue === 'dark' ? '#7379FF' : '#5256A6'} />
                </div>
            );
            break;
        case 'csv':
            iconComponent = (
                <div className="mx-2 mt-1 h-7 w-7">
                    <FileText color={themeValue === 'dark' ? '#7379FF' : '#5256A6'} />
                </div>
            );
            break;
        default:
            iconComponent = <div>N</div>;
    }

    return iconComponent;
};